import { createAction } from '@reduxjs/toolkit';
export const FETCH_CALL_RECORDING = 'FETCH_CALL_RECORDING';
export const fetchCallRecordingAction = createAction(FETCH_CALL_RECORDING);